import { ACTION_TYPES } from './store/actions';
import { globalApi } from '../api';
import { updateContainerId } from 'app/modules/gtm/service/gtm.service';

export const getGlobalConf: () => void = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_CONF,
    payload: globalApi.getGlobalConfig(),
  });

  const configuration = await getState().global.configuration;

  if (configuration && configuration.containerId && configuration.containerId !== '') {
    await dispatch(updateContainerId(configuration.containerId));
  }
};

const randomAvatar = (avatarList: any) => {
  if (avatarList) {
    return avatarList[Math.floor(Math.random() * avatarList?.length)];
  }
  return null;
};

export const setDeviceType = (deviceType: any) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_DEVICE_TYPE,
    payload: deviceType,
  });
};

export const getAvatar = (avatarList: any[]) => async dispatch => {
  dispatch({
    type: ACTION_TYPES.GET_AVATAR_LIST,
    payload: avatarList,
  });

  dispatch({
    type: ACTION_TYPES.GET_AVATAR,
    payload: await randomAvatar(avatarList),
  });
};

export const getSellingPoints = (name: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_SELLING_POINTS,
    payload: globalApi.getSellingPoints(name),
  });
};
